import { css, unsafeCSS } from 'lit';
import { buttonOnDarkStyles } from '../button/button--onDark.styles'
import { checkboxOnDarkStyles } from '@/components/checkbox/checkbox--onDark.styles'
import { linkOnDarkStyles } from '@/components/link/link--onDark.styles'
import { inputOnDarkStyles } from '@/components/input/input--onDark.styles'
import {annotationOnDarkStyles} from "@/components/annotation/annotation--onDark.styles";
import {radioOnDarkStyles} from "@/components/radio/radio--onDark.styles";
import { labelOnDarkStyles } from "@/components/label/label--onDark.styles";
import { roundButtonOnDarkStyles } from '../round-button/round-button--onDark.styles'
import { listAlternativStyles } from '../list/list--onDark.styles';
import {selectOnDarkStyles} from "@/components/select/select--onDark.styles";
import {selectOptionOnDarkStyles} from "@/components/select-option/select-option--onDark.styles";
import {toggleOnDarkStyles} from "@/components/toggle/toggle--onDark.styles";
import { tabItemOnDarkStyles } from "../tab-menu-item/tab-menu-item--onDark.styles";
import { accordionOnDarkStyles } from '../accordion/accordion--onDark.styles';
import { facet1OnDarkStyles } from '../image/styles/facet-1--onDark.styles';
import { facet2OnDarkStyles } from '../image/styles/facet-2--onDark.styles';
import {sbkCoreBreakpointLg} from '@/tokens/variables.js';
import {heroTeaserOnDarkStyles} from '@/components/hero-teaser/hero-teaser--onDark.styles';
import {contentSliderOnDarkStyles} from "@/components/content-slider/content-slider--onDark.styles.ts";
import {citationTeaserOnDarkStyles} from "@/components/citation-teaser/citation-teaser--onDark.styles";
import {globalStyleOnDark} from "@/styles/styles--onDark"
import {tagOnDarkStyles} from "@/components/tag/tag--onDark.styles";
import {tabMenuOnDarkStyles} from "@/components/tab-menu/tab-menu--onDark.styles.ts";
import {copyLinkOnDarkStyle} from "@/components/copy-link/copy-link--onDark.styles";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
        :host {
                display: block;
            position: relative;
                --banner__border-radius: var(--_banner__border-radius, var(--sbkBannerBoxBorderRadiusLg));
                --banner__padding-right: var(--_banner__padding-right, var(--sbkBannerBoxSpacingSmallScrInsetRight));
                --banner__padding-left: var(--_banner__padding-left, var(--sbkBannerBoxSpacingSmallScrInsetLeft));
        }

        * {
                box-sizing: border-box;
        }

        @media all and (min-width: ${breakpointLg}) {
                :host {
                        --banner__padding-right: var(--_banner__padding-right, var(--sbkBannerBoxSpacingLargeScrInsetRight));
                        --banner__padding-left: var(--_banner__padding-left, var(--sbkBannerBoxSpacingLargeScrInsetLeft));
                }
        }

        :host .banner-bg-emphasised {
                color: var(--sbkColorContentFgColorOnDarkDefault);
                ${buttonOnDarkStyles}
                ${labelOnDarkStyles}
                ${linkOnDarkStyles}
                ${annotationOnDarkStyles}
                ${inputOnDarkStyles}
                ${checkboxOnDarkStyles}
                ${listAlternativStyles}
                ${radioOnDarkStyles}
                ${roundButtonOnDarkStyles}
                ${selectOnDarkStyles}
                ${selectOptionOnDarkStyles}
                ${tabItemOnDarkStyles}
                ${tabMenuOnDarkStyles}
                ${toggleOnDarkStyles}
                ${accordionOnDarkStyles}
                ${facet1OnDarkStyles}
                ${facet2OnDarkStyles}
                ${heroTeaserOnDarkStyles}
                ${contentSliderOnDarkStyles}
                ${citationTeaserOnDarkStyles}
                ${globalStyleOnDark}
                ${tagOnDarkStyles}
                ${copyLinkOnDarkStyle}
        }

        .banner {
                border-radius: var(--banner__border-radius);
                margin: 0;
                padding: var(--sbkBannerBoxSpacingSmallScrInsetTop) var(--banner__padding-right) var(--sbkBannerBoxSpacingSmallScrInsetBottom) var(--banner__padding-left);
                display: block;
            height: 100%;

                @media all and (min-width: ${breakpointLg}) {
                        padding: var(--sbkBannerBoxSpacingLargeScrInsetTop) var(--banner__padding-right) var(--sbkBannerBoxSpacingLargeScrInsetBottom) var(--banner__padding-left);
                }
        }

        .banner-bg-default {
                background-color: var(--sbkBannerBoxColorBgColorDefault);
                padding: 0 var(--banner__padding-right) 0 var(--banner__padding-left);
                @media all and (min-width: ${breakpointLg}) {
                        padding: 0 var(--banner__padding-right) 0 var(--banner__padding-left);
                }

        }

        .banner-bg-neutral {
                background-color: var(--sbkBannerBoxColorBgColorNeutral);
        }

        .banner-bg-muted {
                background-color: var(--sbkBannerBoxColorBgColorMuted);
        }

        .banner-bg-accented {
                background-color: var(--sbkBannerBoxColorBgColorAccented);
        }

        .banner-bg-emphasised {
                background-color: var(--sbkBannerBoxColorBgColorEmphasised);
        }

        .has-round-border {
                border-radius: var(--sbkBannerBoxBorderRadiusLg);
        }
`;
